import '@babel/runtime/helpers/extends';
import 'react';
import '@emotion/react';
import SvgAntiAgingGlyphSecondary from './svgs/AntiAgingGlyphSecondary.js';
import { useIcon } from '../../shared-components/icon/index.js';

var antiAgingGlyph = (props => useIcon(null, SvgAntiAgingGlyphSecondary, props));

export { antiAgingGlyph as default };
